<template>
	<ViewWrapper :carregando="loading" :permissao="PERMISSOES_FGTAS.VISUALIZAR_ATENDIMENTO">
		<template #titulo>
			Consulta de Atendimentos
		</template>
		<template #botaoHeader>
			<v-row justify="center">
				<v-col cols="4" class="align-content-center">
					<v-btn
						block
						:color="corTexto"
						variant="outlined"
						text="GERAR XLSX"
						@click="gerarArquivo"
					></v-btn>
				</v-col>
				<v-col cols="4" class="align-content-center">
					<v-btn
						block
						:color="corTexto"
						variant="outlined"
						text="LIMPAR"
						@click="limparFiltros"
					></v-btn>
				</v-col>
				<v-col cols="4" class="align-content-center">
					<v-btn
						block
						color="primary"
						text="PESQUISAR"
						:disabled="validaRange"
						@click="consultaAtendimentos()"
					></v-btn>
				</v-col>
			</v-row>
		</template>
		<v-container fluid>
			<v-row>
				<v-col cols="12" md="2">
					<div class="mb-2 mr-6 text-hidden">Atendente</div>
					<v-combobox v-model="filtros.atendente" :items="listaUsuarios" item-title="nome" item-value="id" />
				</v-col>
				<v-col cols="12" md="2">
					<div class="mb-2 mr-6 text-hidden">Agência</div>
					<v-combobox v-model="filtros.agencia" :items="listaAgencias" item-title="nome" item-value="id" />
				</v-col>
				<v-col cols="12" md="2">
					<div class="mb-2 mr-6 text-hidden">Setor</div>
					<v-combobox v-model="filtros.setor" :items="listaSetor" item-title="nome" item-value="id" />
				</v-col>
				<v-col cols="12" md="2">
					<div class="mb-2 mr-6 text-hidden">Canal de atendimento</div>
					<v-combobox v-model="filtros.canalAtendimento" :items="canaisAtendimento" item-title="title" item-value="value" />
				</v-col>
				<v-col cols="12" md="2">
					<div class="mb-2 mr-6 text-hidden">Serviços</div>
					<v-combobox v-model="filtros.servicos" :items="listaServicos" multiple item-title="nome" item-value="id" />
				</v-col>
				<v-col cols="12" md="2">
					<div class="mb-2 mr-6 text-hidden">Data do Atendimento</div>
					<v-mask-input v-model="filtros.dataAtendimento" readonly :error-messages="validaRange" append-inner-icon="mdi-calendar-range">
						<v-dialog v-model="mostraData" activator="parent" width="auto">
							<v-date-picker multiple="range" v-model="dataAtendimento" elevation="24" />
						</v-dialog>
					</v-mask-input>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-data-table
						:loading="loading"
						:page="pagination.currentPage"
						:items-per-page="pagination.perPage"
						:headers="headers"
						:server-items-length="pagination.totalRows"
						:items="listaAtendimentos"
						no-data-text="Nenhum dado encontrado!"
						loading-text="Carregando..."
						:footer-props="{
							itemsPerPageText: 'Itens por página: ',
							disableItemsPerPage:true,
							disablePagination:true,
						}"
						hide-default-footer
						/>
					<v-container class="mt-0 pa-0">
						<v-row class="pa-0">
							<v-col class="ml-2 d-flex align-center">
								<span class="mr-5 mt-3 fs-15">{{ textoPaginacao }}</span>
							</v-col>
							<v-col class="d-flex justify-end">
								<v-pagination
									:disabled="loading || validaRange"
									total-visible=7
									:model-value="pagination.currentPage"
									@update:model-value="(event) => pagination.currentPage = event"
									:length="pagination.totalPages"
									/>
							</v-col>
						</v-row>
					</v-container>
				</v-col>
			</v-row>
		</v-container>
	</ViewWrapper>
</template>
<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import ViewWrapper from '@/components/commons/wrapper/ViewWrapper.vue';
import { ErroAlert, AtencaoAlert } from "@/utils/AlertUtils.js";
import { vuetify } from '@/plugins/vuetify'
import { PERMISSOES_FGTAS } from '@/utils/PermissaoUtils';
import { buscarAtendimentosPaginado, exportarAtendimento } from '@/services/AtendimentoService';
import { useStore } from 'vuex';
import { buscarAgencias } from '@/services/AgenciaService';
import { buscarUsuariosAtendimento } from '@/services/UsuarioService';
import { listarServicos, listarSetores } from '@/services/ConsultaEntidadeService';
import { format } from "date-fns";

const store = useStore()

const headers = [
	{ key: "atendente.nome", title: "ATENDENTE", sortable: false, align: "center" },
	{ key: "agencia.nome", title: "AGÊNCIA", sortable: false, align: "center" },
	{ key: "setor", title: "SETOR", sortable: false, align: "center" },
	{ key: "canalAtendimento", title: "CANAL DE ATENDIMENTO", sortable: false, align: "center" },
	{ key: "servico", title: "SERVIÇOS", sortable: false, align: "center" },
	{ key: "dataCadastroAtendimento", title: "DATA DO ATENDIMENTO", sortable: false, align: "center" },
];

const loading = ref(false);
const listaAtendimentos = ref([]);
const listaUsuarios = ref([]);
const listaAgencias = ref([]);
const listaSetor = ref([]);
const listaServicos = ref([]);
const mostraData = ref(false);
const dataAtendimento = ref([]);
const filtros = ref({
	atendente: undefined,
	agencia: undefined,
	setor: undefined,
	canalAtendimento: undefined,
	servicos: undefined,
	dataAtendimento: undefined,
});

const canaisAtendimento = [
  { title: "Presencial", value: "PRESENCIAL" },
  { title: "Online", value: "ONLINE" },
];

const pagination = ref({
	page: 0,
	size: 10,
	perPage: 10,
	currentPage: 1,
	totalRows: 0,
	totalPages: 0,
	sort: "dataCadastroAtendimento,desc"
});

const corTexto = computed(() => {
	return vuetify.theme.current.value.dark ? "white" : "primary";
});

const validaRange = computed(() => {
	if (dataAtendimento.value.length > 31) {
		return "Selecione um período de no máximo 31 dias.";
	}
	return undefined;
});

const textoPaginacao = computed(() => {
	if(pagination.value.totalRows){
		if(pagination.value.totalRows === 0){
			return "Nenhum registro localizado";
		}
		if(pagination.value.totalRows === 1){
			return "1 registro recuperado";
		}
		return `${pagination.value.totalRows} registros recuperados`;
	}
	return "";
});

async function consultaAtendimentos(page) {
	pagination.value.currentPage = page ? pagination.value.currentPage : 1;
	pagination.value.page = page ? pagination.value.currentPage - 1 : 0;
	let dataInicio = undefined;
	let dataFim = undefined;
	if (dataAtendimento.value.length === 1) {
		dataInicio = format(dataAtendimento.value[0], "dd/MM/yyyy");
		dataFim = format(dataAtendimento.value[0], "dd/MM/yyyy");
	}
	if (dataAtendimento.value.length > 1 && dataAtendimento.value.length <= 31) {
		dataInicio = format(dataAtendimento.value[0], "dd/MM/yyyy");
		dataFim = format(dataAtendimento.value[dataAtendimento.value.length - 1], "dd/MM/yyyy");
	}
	if (dataAtendimento.value.length > 31) {
		ErroAlert({ mensagem: "Selecione um período de no máximo 31 dias."});
		return;
	}
	loading.value = true;
	await buscarAtendimentosPaginado({
		page: pagination.value.page,
		size: pagination.value.size,
		perPage: pagination.value.perPage,
		currentPage: pagination.value.currentPage,
		sort: pagination.value.sort,
	}, {
		nomeAtendente: filtros.value.atendente ? filtros.value.atendente.nome : undefined,
		agenciaId: filtros.value.agencia ? filtros.value.agencia.id : undefined,
		setor: filtros.value.setor ? filtros.value.setor.nome : undefined,
		canalAtendimento: filtros.value.canalAtendimento ? filtros.value.canalAtendimento.value : undefined,
		servicos: filtros.value.servicos ? filtros.value.servicos.map((x) => x.nome).join(",") : undefined,
		dataInicio: dataInicio,
		dataFim: dataFim,
	})
		.then(({ data }) => {
			pagination.value.size = data.size;
			pagination.value.totalPages = data.totalPages;
			listaAtendimentos.value = data.content;
			pagination.value.totalRows = data.totalElements;
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível lista os usuários no momento. Tente novamente mais tarde!", error });
		})
		.finally(() => loading.value = false);
}

async function limparFiltros() {
	filtros.value.atendente = undefined;
	filtros.value.agencia = undefined;
	filtros.value.setor = undefined;
	filtros.value.canalAtendimento = undefined;
	filtros.value.servicos = undefined;
	filtros.value.dataAtendimento = undefined;
	dataAtendimento.value = [];
	await consultaAtendimentos();
}

async function gerarArquivo() {
	if (
		!filtros.value.atendente &&
		!filtros.value.agencia &&
		!filtros.value.setor &&
		!filtros.value.canalAtendimento &&
		!filtros.value.servicos &&
		!filtros.value.dataAtendimento
	) {
		AtencaoAlert({ mensagem: "Selecione pelo menos um filtro para gerar o XLSX!"});
		return;
	}
	let dataInicio = undefined;
	let dataFim = undefined;
	if (dataAtendimento.value.length === 1) {
		dataInicio = format(dataAtendimento.value[0], "dd/MM/yyyy");
		dataFim = format(dataAtendimento.value[0], "dd/MM/yyyy");
	}
	else if (dataAtendimento.value.length > 1 && dataAtendimento.value.length <= 31) {
		dataInicio = format(dataAtendimento.value[0], "dd/MM/yyyy");
		dataFim = format(dataAtendimento.value[dataAtendimento.value.length - 1], "dd/MM/yyyy");
	}
	else if (dataAtendimento.value.length > 31) {
		ErroAlert({ mensagem: "Selecione um período de no máximo 31 dias."});
		return;
	}
	loading.value = true;
	await exportarAtendimento({
		page: pagination.value.currentPage - 1,
		size: pagination.value.size,
		perPage: pagination.value.perPage,
		currentPage: pagination.value.currentPage,
		sort: pagination.value.sort,
	}, {
		nomeAtendente: filtros.value.atendente ? filtros.value.atendente.nome : undefined,
		agenciaId: filtros.value.agencia ? filtros.value.agencia.id : undefined,
		setor: filtros.value.setor ? filtros.value.setor.nome : undefined,
		canalAtendimento: filtros.value.canalAtendimento ? filtros.value.canalAtendimento.value : undefined,
		servicos: filtros.value.servicos ? filtros.value.servicos.map((x) => x.nome).join(",") : undefined,
		dataInicio: dataInicio,
		dataFim: dataFim,
	})
		.then(async ({ data }) => {
			const a = document.createElement("a");
			document.body.appendChild(a);
			a.style = "display: none";

			const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
			const url = window.URL.createObjectURL(blob);
			a.href = url;
			a.download = "atendimentos.xlsx";
			a.click();
			window.URL.revokeObjectURL(url);
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível baixar o anexo no momento. Tente novamente mais tarde", error });
		})
		.finally(() => loading.value = false);
}

watch(dataAtendimento, () => {
	if (dataAtendimento.value.length === 0) {
		return;
	}
	if (dataAtendimento.value.length === 1) {
		filtros.value.dataAtendimento = format(dataAtendimento.value[0], "dd/MM/yyyy");
		return;
	}
	filtros.value.dataAtendimento = `${format(dataAtendimento.value[0], "dd/MM/yyyy")} até ${format(dataAtendimento.value[dataAtendimento.value.length - 1], "dd/MM/yyyy")}`;
});

async function buscaAgencias() {
	if (store.getters["entidades/getListaAgencias"].length) {
		listaAgencias.value = store.getters["entidades/getListaAgencias"];
		return;
	}
	await buscarAgencias()
		.then(({ data }) => {
			listaAgencias.value = data;
			store.commit("entidades/setListaAgencias", data)
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function buscaUsuarios() {
	await buscarUsuariosAtendimento()
		.then(({ data }) => {
			listaUsuarios.value = data;
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function buscaSetores() {
	if (store.getters["entidades/getListaSetores"].length) {
		listaSetor.value = store.getters["entidades/getListaSetores"];
		return;
	}
	await listarSetores()
		.then(({ data }) => {
			listaSetor.value = data;
			store.commit("entidades/setListaSetores", data);
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function buscaServicos() {
	await listarServicos()
		.then(({ data }) => {
			listaServicos.value = data;
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}
watch(() => pagination.value.currentPage, async (newValue, oldValue) => {
	if (newValue !== oldValue) {
		await consultaAtendimentos(newValue);
	}
}, { deep: true });

onMounted(async () => {
	await buscaAgencias();
	await buscaUsuarios();
	await buscaSetores();
	await buscaServicos();
	await consultaAtendimentos();
});
</script>
